module.exports = __webpack_public_path__ + "img/20190729160553785.bae8cb55.png";